import { Injectable } from '@angular/core';
import { FormatOptions } from './interfaces/format-service.interface';
import { NumericFormatUtilsService } from './numeric-format-utils.service';

@Injectable()
export class NumberFormatService {

  constructor(private numericFormatUtilsService: NumericFormatUtilsService) { }

  formatData(data: string | number, formatOptions: Partial<FormatOptions>) {
    let formatData;
    formatData = this.numericFormatUtilsService.formatPercent(data, formatOptions.applyPercentage,
      formatOptions.showAsPercentageOfTotal);

    formatData = this.numericFormatUtilsService.formatDecimalPoint(formatData, formatOptions.decimalPointNumber,
      formatOptions.autoToFixed);

    formatData = this.numericFormatUtilsService.formatSeparator(formatData, formatOptions.hasSeparator);


    formatData = this.numericFormatUtilsService.formatSign(formatData, formatOptions.hasDollarSign,
      formatOptions.hasPercentSign || formatOptions.applyPercentage , formatOptions.hasSeparator);

    if (!isNaN(+data)) {
      formatData = this.numericFormatUtilsService.addUnitSign(formatData, formatOptions.unit, formatOptions.maxValue);
    }
    formatData = this.numericFormatUtilsService.formatMinus(formatData, formatOptions.formatType,
      formatOptions.negativeNumberFormat);
    return formatData;
  }
}
